import {
    EPpGuideOrientation,
    IGuide,
    IGuideModel,
    IMasterLayoutGuides,
} from '@src/slide/domain/ui-model/element-modeles/Interface/guide-model.interface';
import _set from 'lodash/set';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { observable } from 'mobx';

export class Guide implements IGuide {
    public type = UIModelType.GUIDES;
    /**
     * 参考线方向
     */
    @observable public orient: EPpGuideOrientation;

    /**
     * 对齐线颜色
     */
    @observable public color: string;

    /**
     * 对齐线位置，沿x/y轴计算
     */
    @observable public pos: number;
}

export default class GuideModel implements IGuideModel {
    public static async convertDataUiToSdk(uiData, sdkData, rawUiModel, option?) {
        if (uiData?.props?.slideGuides) {
            _set(sdkData, 'guides.slideGuides', uiData.props.slideGuides);
        }
        if (uiData?.props?.masterGuides) {
            _set(sdkData, 'guides.masterGuides', uiData.props.masterGuides);
        }
        if (uiData?.props?.layoutGuides) {
            _set(sdkData, 'guides.layoutGuides', uiData.props.layoutGuides);
        }
    }

    public static async convertDataSdkToUi(sdkData, uiData, rawSdkData, option?) {
        if (sdkData?.guides?.slideGuides) {
            _set(uiData, 'slideGuides', sdkData.guides.slideGuides);
        }
        if (sdkData?.guides?.masterGuides) {
            _set(uiData, 'masterGuides', sdkData.guides.masterGuides);
        }
        if (sdkData?.guides?.layoutGuides) {
            _set(uiData, 'layoutGuides', sdkData.guides.layoutGuides);
        }
    }

    public slideGuides: Array<IGuide> = [];
    public masterGuides: Array<IMasterLayoutGuides> = [];
    public layoutGuides: Array<IMasterLayoutGuides> = [];
    public type = UIModelType.GUIDES;
    private sdkData: any;

    public updateGuidesPropsNoUndo(): void {
        // todo muzzy 待用src/slide/application/service/guides-manager/index.ts替换
    }

    public async bindSDK(sdkData): Promise<void> {
        if (sdkData) {
            this.sdkData = sdkData;
            const promise = GuideModel.convertDataSdkToUi(this.preprocessedSDKData, this, this.sdkData, {});
            if (promise) {
                await promise;
            }
        } else {
            this.unbindSDK();
        }
    }

    public unbindSDK() {
        if (this.sdkData) {
            this.sdkData = null;
        }
    }

    private get preprocessedSDKData(): any {
        const mergedSDKData = this.sdkData?.getDataByInheritedProperties?.();
        return mergedSDKData || this.sdkData;
    }

    private prepareSDKPropsData(props): any {
        const uiModel = {
            props,
        };
        const sdkData = {};
        Object.getPrototypeOf(this).constructor.convertDataUiToSdk(uiModel, sdkData, this);
        return sdkData;
    }
}
